(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-showcase-carousel"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    document.querySelectorAll('.product-showcase-carousel').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';

      var thumbsEl = root.querySelector('.product-showcase-carousel-thumbs');
      var thumbsSwiper = thumbsEl
        ? new Swiper(thumbsEl, {
            slidesPerView: 4,
            spaceBetween: 12,
            watchSlidesProgress: true,
            breakpoints: {
              750: { slidesPerView: 5 },
            },
          })
        : null;

      var prevEl = root.querySelector('.product-showcase-carousel-nav.prev');
      var nextEl = root.querySelector('.product-showcase-carousel-nav.next');

      new Swiper(root.querySelector('.product-showcase-carousel-main'), {
        spaceBetween: 16,
        navigation: prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : undefined,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      });

      root.querySelectorAll('.product-showcase-carousel-play').forEach(function (button) {
        button.addEventListener('click', function () {
          var wrapper = button.closest('.product-showcase-carousel-video');
          var template = wrapper.querySelector('template');
          wrapper.innerHTML = template.innerHTML;
          var video = wrapper.querySelector('video');
          if (video) video.play();
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
